<script lang="jsx">
import BuyNow from './buy-now.vue';
import BuyTrial from './buy-trial.vue';
import Edit from "./edit.vue";
import EditDelta from "./edit-delta.vue";
import Add from "./add.vue";
import Upgrade from './upgrade.vue';
import Upsell from './upsell.vue';
import Trial2paid from './trial2paid.vue';
import { computedPbxBasePlans } from '@/common/service/computers/plans/pbx';
import { mapGetters } from 'vuex';
import { planTypes } from '@/common/constants';

export default {
  props: {
    configPlanTileStatus: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['boughtPlans', 'migratePlanState', 'basicConfig', 'boughtBizPlusFreeTrialAsBasePlan']),
    hasBoughtPbxBasePlan(){
      return !!computedPbxBasePlans(this.boughtPlans).length;
    },
  },
  render() {
    const context = {...this.$props, ...this.$attrs};
    if (
      this.$context.is.biz2bundle ||
      this.$context.is.pro2bundle ||
      this.migratePlanState.is.upgrade
    ) return <Upgrade {...context} />;
    if (this.$context.is.modalDelta) return <EditDelta {...context} />;
    if (this.$context.is.edit) return <Edit {...context} />;
    if (this.$context.is.add2cart) {
      // auto add paid add on plan for zoom one bundle base plan free trial case
      if (this.$config('editConfig.planType') !== planTypes.ZOOM_ONE_BUNDLE && this.boughtBizPlusFreeTrialAsBasePlan) return <Trial2paid {...context} />;
      if (this.basicConfig?.isBulkLicenseAccount) return <Add {...context} />;
      if (this.hasBoughtPbxBasePlan) return <Edit {...context} />;
      return <Add {...context} />;
    }
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...context} />;
    if (this.$context.is.upsell) return <Upsell {...context} />;
    if (this.$context.is.buyTrial) return <BuyTrial {...context} />;
    if (this.$context.is.trial2paid) return <Trial2paid {...context} />;
    return null;
  },
};
</script>
